import { paymentOrderData } from '../shop';
import { request } from '../../helpers/requestHelper';
import { returnMsg } from '../../helpers/shop/paymentHelper';
import { msg as swalMsg } from '../swal_msg';
import { SUPPORT_NUMBER_VIEW } from '../../constants/constants';

const CONFIG = {
    PayPal: {
        endpoint: 'payment/paypal/generate-payment',
        key: 'paypal'
    },
    OpenPay: {
        endpoint: 'payment/openpay/payment-charge',
        key: 'openpay'
    },
    MercadoPago: {
        endpoint: 'payment/mercadopago/payment-preference',
        key: 'mercadopago'
    }
};

export const retryPayment = (provider, orderId, setDisabled) => async dispatch => {
    try {
        const config = CONFIG[provider];
        const response = await request(config.endpoint, { _id: orderId }, 'POST');
        const body = await response.json();

        if (body.status) {
            const resolvedProvider = body.resp?.provider || provider;
            const resolvedConfig = CONFIG[resolvedProvider];
            const paymentUrl = body.resp?.payment_url || body.resp?.redirect_url || body.resp?.init_point || '';
            if (!resolvedConfig || !paymentUrl) {
                await returnMsg({ status: false, msg: 'payment-link-unavailable' }, provider);
                return { status: false, msg: 'payment-link-unavailable' };
            }
            dispatch(paymentOrderData({
                [resolvedConfig.key]: {
                    generate: false,
                    message: 'Continúe con su pago',
                    payment_url: paymentUrl
                }
            }));
            return { ...body, resp: { ...body.resp, provider: resolvedProvider, payment_url: paymentUrl } };
        }

        if (['order-already-paid', 'payment-method-active'].includes(body.msg)) return body;
        await returnMsg(body, provider);
        return body;
    } catch (error) {
        swalMsg(
            'error',
            provider,
            `No se pudo comprobar el pago. Comuníquese con nosotros: ${SUPPORT_NUMBER_VIEW}`
        );
        return { status: false, msg: 'request-err' };
    } finally {
        setDisabled(false);
    }
};

export const checkOrderPaymentStatus = async orderId => {
    try {
        const response = await request('payment/order-status', {
            _id: orderId,
            cart_token: localStorage.getItem('cart-token') || ''
        }, 'POST');
        return await response.json();
    } catch (error) {
        return { status: false, msg: 'request-err' };
    }
};

export const reconcileOrderPayment = async orderId => {
    try {
        const response = await request('payment/order-reconcile', {
            _id: orderId,
            cart_token: localStorage.getItem('cart-token') || ''
        }, 'POST');
        return await response.json();
    } catch (error) {
        return { status: false, msg: 'request-err' };
    }
};
